import React, {useRef, useContext} from 'react';
import {Card, ListGroup} from 'react-bootstrap';
import {MDBCheckbox} from 'mdb-react-ui-kit';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowRight, faPencilAlt} from '@fortawesome/free-solid-svg-icons';
import {useNavigate} from 'react-router';
import { MadricContext } from '../../../Context/MadricContext';

/**
 *  L'accueil
 * @return {JSX}
 */
function Note(props) {
  const navigate = useNavigate();
  const {setWhatToShow, setActiveLink} = useContext(MadricContext);
  const note = props.note;
  const returnTo = 'global';
  
  return (
    <div className="checkin-container" key={props.note.id}>
      <Card className="checkin-card">
        <Card.Header className="checkin-header">
          <span style={{fontWeight: 'bold', textDecoration: 'underline'}}>NOTE</span> {props.formatDate(props.note.date)}
          <button style={{marginLeft:"5px"}} className="checkin-pagination-button float-end" onClick={() => {setWhatToShow('6'); navigate('/chantier/' + props.note.place_id); setActiveLink('chantiers')}}><FontAwesomeIcon icon={faArrowRight} /></button>
          <button className="checkin-pagination-button float-end" onClick={() => {navigate('/UpdateNote', {state: {note, returnTo}}); setActiveLink('chantiers')}}><FontAwesomeIcon icon={faPencilAlt} /></button>
        </Card.Header>

        <ListGroup variant="flush">
        <ListGroup.Item className="checkin-list-item" style={{fontWeight:"bold", fontSize:"18px"}}>
            {props.note.user_name}
          </ListGroup.Item>
        <ListGroup.Item className="checkin-list-item">
            Projet: {props.note.place_name}
          </ListGroup.Item>

          <ListGroup.Item>
            <MDBCheckbox
              name="extra1"
              id="inlineCheckbox111"
              defaultChecked={props.note.extra1}
              label="Extra possible"
              disabled
              inline
            />
            {localStorage.getItem('admin') === '1' ? (
              <React.Fragment>
                <MDBCheckbox
                  name="extra2"
                  id="inlineCheckbox222"
                  defaultChecked={props.note.extra2}
                  label="Extra valider"
                  disabled
                  inline
                />
                <MDBCheckbox
                  name="extra3"
                  id="inlineCheckbox333"
                  defaultChecked={props.note.extra3}
                  label="Extra confirmer"
                  disabled
                  inline
                />
              </React.Fragment>
            ) : (
              ' '
            )}
          </ListGroup.Item>
          <ListGroup.Item className="checkin-list-item ">
            Note: {props.note.note}
          </ListGroup.Item>
        </ListGroup>
      </Card>
    </div>
  );
}

export default Note;